import MDInput from "../../../../materialDashboard/components/MDInput";
import MenuItem from "@mui/material/MenuItem";
import React from "react";

const GenericParameterSelect = ({ label, value, onChange, params = [], ...props }) => {
    return (
        <MDInput
            select
            value={value ?? ''}
            onChange={onChange}
            variant="standard"
            fullWidth
            label={label}
            SelectProps={{
                displayEmpty: true,
            }}
            InputLabelProps={{
                shrink: true,
            }}
            {...props}
        >
            {params.map((p) => (
                <MenuItem key={p.code} value={p.code}>
                    {p.description || p.code}
                </MenuItem>
            ))}
        </MDInput>
    );
};

export default GenericParameterSelect;
